import { render, staticRenderFns } from "./SignerUpdate.vue?vue&type=template&id=e48941be"
import script from "./SignerUpdate.vue?vue&type=script&lang=js"
export * from "./SignerUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports